;(function( window, document, $, undefined ) {
	'use strict';

	// Team List

	function teamList() {

    // Init
    function init( $el, $target ) {

      if( $('.team-page').length > 0 ) {

        $('.team-page').on('click', '.team-list__media', function(e){
          e.preventDefault();
          var $this = $(this);
          var $parent = $this.closest('.team-list__item');
          var $infos = $parent.find('.team-list__infos');

          var imgLength = $parent.find('img').length;

          if( $parent.hasClass('active') ) {
            $parent.removeClass('active imgEffect');
            setTimeout(function(){
              $infos.css('z-index', -1);
            }, 50);
          } else {
            $('.team-list__item').removeClass('active');
            $('.team-list__infos').css('z-index', -1);
            $infos.css('z-index', 1);
            setTimeout(function(){
              $parent.addClass('active');
              if( imgLength > 1 ) { $parent.addClass('imgEffect'); }
            }, 50);
          }
        });

        $('.team-list__menu a').eq(0).addClass('active');

        function showTeam() {
          var $categoryActive = $('.team-list__menu .active').data('teamcategories');
          var $categoryActiveTitle = $('.team-list__menu .active').text();
          $('.team-title').text( $categoryActiveTitle );

          $('.team-list').empty().removeClass('grid').append( $('.team-list__item[data-category="' + $categoryActive + '"]' ).clone() ).addClass('grid');
          $('.team-list .team-list__item').fadeIn();

          $("html, body").animate({ scrollTop: $('.team-title').offset().top - 50 }, 100);
        }
        showTeam();

        $('.team-list__menu a').click(function(e){
          e.preventDefault();
          $('.team-list__menu a').removeClass('active');
          $(this).addClass('active');
          showTeam();
        });

        $('.team-next').click(function(){
          var $categoryActive = $('.team-list__menu .active');
          $categoryActive.removeClass('active');

          if( $categoryActive.is(':last-child()') ) {
            $('.team-list__menu a').eq(0).addClass('active');
          } else {
            $categoryActive.next().addClass('active');
          }
          showTeam();
        });

        $('.team-prev').click(function(){
          var $categoryActive = $('.team-list__menu .active');
          $categoryActive.removeClass('active');

          if( $categoryActive.is(':first-child()') ) {
            $('.team-list__menu a').eq(-1).addClass('active');
          } else {
            $categoryActive.prev().addClass('active');
          }
          showTeam();
        });
      }

    }

		// Globals
		return {
      init: init
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.teamList = teamList();

})( window, document, jQuery );
